/**
 * 残り時間の表示（基本設計書 7.8）。
 *
 * サーバーが返す残り秒数を起点に、画面側で1秒ずつ減らす。
 * 毎秒サーバーへ問い合わせるのは、会場の回線と参加者の人数を考えると現実的でない。
 * ずれは time:tick の配信で定期的に補正する。
 *
 * 一時停止中は減らさない。止まっている間も数え続けると、
 * 再開したときに時間が飛んだように見える。
 */

import { useEffect, useState } from "react";

function format(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/** 残りがこれを切ったら色を変える */
const WARN_SEC = 300;
const DANGER_SEC = 60;

export function Countdown({
  remainingSec,
  paused,
}: {
  /** サーバーが返した残り秒数。null は無制限 */
  remainingSec: number | null;
  paused: boolean;
}): React.ReactElement | null {
  const [left, setLeft] = useState(remainingSec);

  // サーバーからの値が届いたら、そこへ合わせ直す
  useEffect(() => {
    setLeft(remainingSec);
  }, [remainingSec]);

  useEffect(() => {
    if (paused || left === null || left <= 0) return;
    const timer = setInterval(() => {
      setLeft((prev) => (prev === null ? null : Math.max(0, prev - 1)));
    }, 1000);
    return () => clearInterval(timer);
  }, [paused, left]);

  // 無制限のイベントでは何も出さない。0:00 と紛らわしい表示を避ける
  if (left === null) return null;

  const level = left <= DANGER_SEC ? "danger" : left <= WARN_SEC ? "warn" : "normal";

  return (
    <div className={`countdown countdown--${level}`}>
      <span className="countdown__label">残り</span>
      <span className="countdown__value">{format(left)}</span>
      {paused && <span className="countdown__paused">停止中</span>}
    </div>
  );
}
